<div class="app-container">
  <!-- Page Header Component -->
  <app-page-header></app-page-header>

  <!-- Main Content -->
  <main class="main-content">
    <div class="welcome-container">
      <div class="welcome-card">
        <div class="welcome-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
            <polyline points="10 9 9 9 8 9"></polyline>
          </svg>
        </div>
        <h1 class="welcome-title">Welcome to DocSila</h1>
        <p class="welcome-subtitle">Document Intelligence & Validation Platform</p>

        <button class="btn-login-primary" (click)="initiateLogin()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
            <polyline points="10 17 15 12 10 7"></polyline>
            <line x1="15" y1="12" x2="3" y2="12"></line>
          </svg>
          Sign In
        </button>

        <p class="login-hint">Sign in with your Flatworld account to continue</p>
      </div>
    </div>
  </main>
</div>
